import { api } from '../../DefaultService';
import { ITotvsCreateProps, ITotvsProps, ITotvsUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/totvs';

export const createTotvsIntegrationAsync = async (data: ITotvsCreateProps) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllTotvsIntegrationsAsync = async (): Promise<
  ITotvsProps[]
> => {
  return await api
    .get<ITotvsProps[]>(`${ENDPOINT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getTotvsIntegrationByIdAsync = async (
  id: number,
): Promise<ITotvsProps> => {
  return await api
    .get<ITotvsProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateTotvsIntegrationAsync = async ({
  id,
  data,
}: ITotvsUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteTotvsIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
